<!-- src/components/FileFolder.vue -->
<template>
  <v-card flat elevation="0" :style="{ paddingLeft: '25px' }">
    <v-list>
      <v-list-group
        v-for="(item, name) in contents"
        :key="name"
        :value="name"
      >
        <template v-slot:activator="{ props }">
          <v-list-item
            v-if="isFolder(item)"
            v-bind="props"
            prepend-icon="mdi-folder"
            :title="name"
          >
            <template v-slot:prepend>
              <v-avatar :color="getFileColor(name)">
                <v-icon color="white">mdi-folder</v-icon>
              </v-avatar>
            </template>
          </v-list-item>

          <v-list-item
            v-else
            class="list-item"
            :title="name"
            :subtitle="formatDate(item.lastModified)"
          >
            <template v-slot:prepend>
              <v-avatar :color="getFileColor(name)">
                <v-icon color="white">{{ getFileIcon(name) }}</v-icon>
              </v-avatar>
            </template>
            <template v-slot:append>
              <v-btn
                v-if="
                  name.toLowerCase().endsWith('.pdf') ||
                  name.toLowerCase().endsWith('.docx') ||
                  name.toLowerCase().endsWith('.pptx')
                "
                class="mr-2"
                @click.stop="previewFile(folder, name)"
              >
                Preview <v-icon>mdi-eye</v-icon>
              </v-btn>
              <v-btn @click.stop="downloadFile(folder, name)">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
          </v-list-item>
        </template>

        <file-folder
          v-if="isFolder(item)"
          :contents="item"
          :folder="folderName(folder, name)"
          @downloadFolder="downloadFolder"
          @downloadFile="downloadFile"
          @previewFile="previewFile"
        ></file-folder>
      </v-list-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "FileFolder",
  props: {
    contents: {
      type: Object,
      required: true,
    },
    folder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      openFolders: [],
    };
  },
  methods: {
    folderName(folder, name) {
      return folder === "" ? name : folder + "/" + name;
    },
    downloadFolder(folder, name) {
      if (name === undefined) {
        this.$emit("downloadFolder", folder);
      } else {
        this.$emit(
          "downloadFolder",
          folder === "" ? name : folder + "/" + name
        );
      }
    },
    downloadFile(folder, name) {
      if (name === undefined) {
        this.$emit("downloadFile", folder);
      } else {
        this.$emit(
          "downloadFile",
          folder === "" ? name : folder + "/" + name
        );
      }
    },
    previewFile(folder, name) {
      if (name === undefined) {
        this.$emit("previewFile", folder);
      } else {
        this.$emit(
          "previewFile",
          folder === "" ? name : folder + "/" + name
        );
      }
    },
    toggleFolder(name) {
      if (this.isOpen(name)) {
        this.openFolders = this.openFolders.filter((f) => f !== name);
      } else {
        this.openFolders.push(name);
      }
    },
    isOpen(name) {
      return this.openFolders.includes(name);
    },
    isFolder(value) {
      return value && !value.lastModified;
    },
    getFileIcon(filename) {
      const ext = filename.toLowerCase();
      if (ext.endsWith(".pdf")) return "mdi-file-pdf";
      if (ext.endsWith(".docx")) return "mdi-file-word";
      if (ext.endsWith(".pptx")) return "mdi-file-powerpoint";
      return "mdi-file-document";
    },
    getFileColor(filename) {
      const ext = filename.toLowerCase();
      if (ext.endsWith(".pdf")) return "red";
      if (ext.endsWith(".docx")) return "blue";
      if (ext.endsWith(".pptx")) return "orange";
      return "grey-lighten-1";
    },
    formatDate(value) {
      if (!value) return "";
      const date = new Date(value);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },
  },
};
</script>

<style scoped>
.highlight {
  background-color: yellow;
}
.folder-icon .v-icon {
  color: purple !important;
}
.list-item {
  cursor: default !important;
  background-color: transparent !important;
}
</style>
